// extracted by mini-css-extract-plugin
export var content = "tile-card-module--content--b34df";
export var featuredImage = "tile-card-module--featured-image--563c6";
export var linkSpacing = "tile-card-module--link-spacing--49278";
export var tileCard = "tile-card-module--tile-card--62a6f";